





























































import { Component, Vue, Prop } from "vue-property-decorator";
@Component({})
export default class SzjxNavLeft extends Vue {
  @Prop()
  private cState;
  private get user() {
    return this.$store.state.user;
  }
}
